exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-banner-medias__top-bar {\n  margin-bottom: 24px;\n}\n.admin-banner-medias__top-bar button {\n  margin-left: 8px;\n}\n", ""]);

// exports
